import React, { useState } from 'react';
import './SlotBlockConfirm.css';

const TXT_MESSAGE = {
    fr: (name) => <>Ajouter <strong>{name}</strong> à la liste d'exclusion ?</>,
    en: (name) => <>Add <strong>{name}</strong> to the exclusion list?</>,
    de: (name) => <><strong>{name}</strong> zur Ausschlussliste hinzufügen?</>,
    es: (name) => <>¿Añadir <strong>{name}</strong> a la lista de exclusión?</>,
    pt: (name) => <>Adicionar <strong>{name}</strong> à lista de exclusão?</>,
};
const TXT_INCLUDE_SET = { fr: 'Exclure toute la panoplie', en: 'Exclude the whole set', de: 'Ganzes Set ausschließen', es: 'Excluir todo el set', pt: 'Excluir todo o conjunto' };
const TXT_CANCEL = { fr: 'Annuler', en: 'Cancel', de: 'Abbrechen', es: 'Cancelar', pt: 'Cancelar' };
const TXT_CONFIRM = { fr: 'Exclure', en: 'Block', de: 'Ausschließen', es: 'Excluir', pt: 'Excluir' };

/**
 * Confirmation dialog shown before blocking (blacklisting) a slot item.
 * Optionally offers to exclude the item's whole set.
 */
const SlotBlockConfirm = ({ itemName, setName = null, lang = 'fr', onConfirm, onCancel }) => {
    const [includeSet, setIncludeSet] = useState(true);
    const message = (TXT_MESSAGE[lang] || TXT_MESSAGE.en)(itemName);

    return (
        <div className="slot-block-confirm column">
            <p className="slot-block-confirm-message">{message}</p>
            {setName && (
                <label className="slot-block-confirm-set checkbox-setting">
                    <input
                        type="checkbox"
                        checked={includeSet}
                        onChange={(e) => setIncludeSet(e.target.checked)}
                    />
                    <span>{TXT_INCLUDE_SET[lang] || TXT_INCLUDE_SET.en} ({setName})</span>
                </label>
            )}
            <div className="slot-block-confirm-actions row">
                <button type="button" onClick={onCancel}>
                    {TXT_CANCEL[lang] || TXT_CANCEL.en}
                </button>
                <button
                    type="button"
                    className="highlight"
                    onClick={() => onConfirm(setName ? includeSet : false)}
                >
                    {TXT_CONFIRM[lang] || TXT_CONFIRM.en}
                </button>
            </div>
        </div>
    );
};

export default SlotBlockConfirm;
